import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../infrastructure/api.service';

export interface SubmitRatingBody {
  readonly rating: number; // 1..5 (całe)
  readonly comment: string | null;
}

@Injectable({ providedIn: 'root' })
export class RatingHttpService extends ApiService {
  submit(body: SubmitRatingBody): Observable<void> {
    return this.httpClient.post<void>(`${this.env.apiUrl}/ratings`, body);
  }
}
